import { bootstrapApplication } from '@angular/platform-browser';
import {
  browserTracingIntegration,
  init as initSentryAngular,
} from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { isRouterInternalSignal } from './app/helpers/is-router-internal-signal';
import { APP_BROWSER_CONFIG } from './app/site/app.browser.config';
import { environment } from './environments/environment';
import { variables } from './environments/variables';

if (environment.sentry) {
  initSentryAngular({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: variables.release,

    integrations: [browserTracingIntegration()],

    // Samples performance monitoring (1.0 captures 100% of transactions)
    tracesSampleRate: environment.sentry.tracesSampleRate,

    // Sentry runs before any consent choice, so it must not carry personal
    // data: the SDK v11 defaults would infer the visitor's IP, attach cookies
    // and copy request bodies (the contact form) onto error spans.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
    },

    // iOS in-app browsers (WKWebView) inject a native bridge script whose
    // pagehide handler throws when window.webkit is missing. It reports the
    // page URL as its file, so denyUrls cannot match it.
    ignoreErrors: [/window\.webkit\.messageHandlers/],

    // The router's private NoMatch / AbsoluteRedirect throws have no message
    // and show up as "Error: No error message"; ignoreErrors cannot match them.
    beforeSend: (event, hint) =>
      isRouterInternalSignal(hint.originalException) ? null : event,
  });
}

bootstrapApplication(AppComponent, APP_BROWSER_CONFIG).catch(
  (error: unknown) => {
    console.error(error);
  },
);
